import { MMLConnectionType } from "../../../Enums/ChoiceEnums";

export function mmlConnectionDesc(connectionType?: MMLConnectionType)
{
    switch(connectionType)
    {
        case MMLConnectionType.Connected: 
            return "Enabled";

        case MMLConnectionType.OptOut:
            return "Opted-Out";
    }
    return "Not Enabled - Invite";
};